import { environment } from 'src/environments/environment';

export const ASSET_PATH_BASE = '/api/v2/assets';
export const ASSET_BASE_URL = environment.basePathCdn + ASSET_PATH_BASE;
export const PRODUCT_CARD_IMAGES_FOLDER_PATH = ASSET_PATH_BASE + '/product-pictures-v2/';
export const IMAGES_FOLDER_PATH = ASSET_PATH_BASE + '/images/';
export const VIDEO_FOLDER_PATH = ASSET_PATH_BASE + '/videos/';
export const K_ICON_PATH = environment.basePathCdn + ASSET_PATH_BASE + '/kicon.png';
